import script from "./GastoManager.vue?vue&type=script&setup=true&lang=js"
export * from "./GastoManager.vue?vue&type=script&setup=true&lang=js"

import "./GastoManager.vue?vue&type=style&index=0&id=0179d65b&lang=css"

const __exports__ = script;

export default __exports__